


















































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { maskDate, maskHour, minutesToHours } from '@/utils/common'

@Component

export default class ComponenteBackofficeDataSolicitadaMedico extends Vue {
  @Prop({ default: false }) exibir: boolean
  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get timeLabel() {
    const tempo = this.getBackofficeGlobalStore.solicitacao.tempoCirurgia || 0
    if (tempo < 60) return `${tempo} minutos`
    return `${tempo} minutos / ${this.minutesToHoursUtil(this.getBackofficeGlobalStore.solicitacao.tempoCirurgia || 0)}`
  }

  formatDate(date: string) {
    return maskDate(date)
  }

  formatHour(date: string) {
    return maskHour(date)
  }

  minutesToHoursUtil(value) {
    return minutesToHours(value)
  }

  configuracaoHabilitada(field: string) {
    return this.getBackofficeGlobalStore
      && this.getBackofficeGlobalStore.template
      && this.getBackofficeGlobalStore.template.formulario
      && this.getBackofficeGlobalStore.template.formulario[field]
      && this.getBackofficeGlobalStore.template.formulario[field].habilitado
  }

  windowWidth: number = 0
  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  get procedureEligibilityData() {
    const spi = this.getBackofficeGlobalStore.solicitacao.solicitacaoProcedimentoInternacao

    // O store força um solicitacaoProcedimentoInternacao vazio (fxsp-638) quando a API
    // não envia esse objeto, para permitir o bind na tela de edição. Esse objeto vazio vem
    // com procedimentoInternacaoId em branco; um registro REAL tem o id preenchido. Só nesse
    // caso montamos a tabela — senão caímos no fallback que exibe solicitacao.diaria.
    const temRegistroReal = !!spi && !['', null, undefined].includes(spi.procedimentoInternacaoId)

    if (temRegistroReal) {
      return [
        {
          ...spi,
        },
      ]
    }

    return []
  }

  get canShowTemplate() {
    return !this.getBackofficeGlobalStore.solicitacao.criadaComoOrcamentoParticularAvulso || this.exibir
  }

  get hasReservaInfo() {
    const { solicitacao } = this.getBackofficeGlobalStore
    return !!(
      solicitacao.numeroAgendamento
      || solicitacao.dataAgendamento
      || solicitacao.salaCirurgicaNome
      || solicitacao.observacaoReservaSala
    )
  }

  get centroCirurgicoExibido(): string {
    const s = this.getBackofficeGlobalStore.solicitacao
    return s.centroCirurgicoSugeridoPeloMedico || (s.centroCirurgico && s.centroCirurgico.nome) || ''
  }
}
